import './scss/style.scss';

function dayDiff(d1, d2)
{
  d1 = new Date(d1);
  d2 = new Date(d2);
  d1 = d1.getTime() / 86400000;
  d2 = d2.getTime() / 86400000;
  return new Number(d2 - d1).toFixed(0);
}
function scrollChat () {
  var x = document.getElementById('chat-content');
  x.scrollTop = x.scrollHeight;
}

jQuery(document).ready(function(){
  var nb_points = jQuery('.points .points-details').html();
  jQuery('#menu-item-164 > a').after('<span>(Mon solde : ' +  nb_points + ' points)</span>')
  jQuery('.widget-chat-closed').click(function(e) {
      jQuery(this).hide();
      jQuery('.widget-chat-opened').show();
      setTimeout(scrollChat, 500);
  });
  jQuery('.widget-chat-opened .btn-close').click(function(e) {
    scrollChat();
      jQuery(this).parent().hide();
      jQuery('.widget-chat-closed').show();
  });
  jQuery('#message-chat').on('submit', function(e) {
    e.preventDefault();
    var val = jQuery('#message').val();
    if (val !== '') {
      jQuery('.chat-content').html('...');
      jQuery('#message').val('');
      jQuery.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          'action': 'chat_message',
          'message': val
        }
      }).done(function(response) {
        jQuery('.chat-content').html(response);
        scrollChat()
      });
    }
  });
  jQuery('.refresh_chat').on('click', function(e) {
      jQuery('.chat-content').html('...');
      jQuery('#message').val('');
      jQuery.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          'action': 'chat_message',
          'message': false
        }
      }).done(function(response) {
        jQuery('.chat-content').html(response);
        scrollChat();
      });
  });

    jQuery('.goBack').click(function(e) {
        e.preventDefault();
        window.history.back();
    });

    jQuery('.btn_supprimer').click(function(e) {
      var message = 'Voulez-vous vraiment supprimer cette donnée ?';
      var id = jQuery(this).attr('data-id');
      if (id) {
        var message = 'Êtes-vous certain de vouloir supprimer le lieu de dépôt n°' + id + ' ?';
      }
      var datamessage = jQuery(this).attr('data-message');
      if (datamessage) {
        var message = datamessage;
      }
        if (window.confirm(message)) { 
        } else {
            e.preventDefault();
        }
    });

    jQuery('.verif_cancel_lot').click(function(e) {
      var message = 'Etes-vous certain d’annuler la déclaration de ce lot ?';
        if (window.confirm(message)) { 
        } else {
            e.preventDefault();
        }
    });

    jQuery('.verif_cancel_pli').click(function(e) {
      var message = 'Etes-vous certain d’annuler la déclaration de ce pli ?';
        if (window.confirm(message)) { 
        } else {
            e.preventDefault();
        }
    });

    jQuery('.verif_cancel_lieu').click(function(e) {
      var message = 'Souhaitez-vous quitter l\'assistant de déclaration des HDL ? Toutes les modifications seront perdues';
        if (window.confirm(message)) { 
        } else {
            e.preventDefault();
        }
    });

    /*jQuery('.form_declarer_lot').submit(function(e) {
      var lieu = jQuery('.lieu_depot').val();
      var hdl_dep = jQuery('.hdl_dep').val();
      var hdl_autre_dep = jQuery('.hdl_autre_dep').val();
        if (lieu == 'hdl' && hdl_dep == '' && hdl_autre_dep == '') { 
          alert('');
          e.preventDefault();
        }
    });*/

    jQuery('.btn_supprimer_impossible').click(function(e) {
      alert('Vous devez toujours bénéficier d’au moins un lieu de dépôt. Merci d’en déclarer un nouveau avant de réaliser cette suppression');
      e.preventDefault();
    });
    

    jQuery('.oui_date_reception').click(function(e) {
        jQuery('.div_date_reception').show();
        jQuery('.div_date_reception input').prop('required', true);
    });
    jQuery('.non_date_reception').click(function(e) {
        jQuery('.div_date_reception').hide();
        jQuery('.div_date_reception input').prop('required', false);
    });

    
    jQuery('.oui_etat_reception').click(function(e) {
        jQuery('.div_non_recu').show();
        if (jQuery('.oui_date_reception').is(':checked')) {
          jQuery('.div_date_reception input').prop('required', true);
          jQuery('.div_date_reception').show();
        } else {
          jQuery('.div_date_reception').hide();
          jQuery('.div_date_reception input').prop('required', false);
        }
        if (jQuery('.etat_tad').val() == 1) {
            jQuery('.div_date_cachet').show();
            jQuery('.div_date_cachet input').prop('required', true);
        } else {
            jQuery('.div_date_cachet').hide();
            jQuery('.div_date_cachet input').prop('required', false);
        }
        jQuery('.div_date_cachet input').prop('required', true);
    });
    jQuery('.non_etat_reception').click(function(e) {
        jQuery('.div_non_recu').hide();
        jQuery('.div_date_reception input').prop('required', false);
        jQuery('.div_date_cachet input').prop('required', false);
    });

    
    jQuery('.etat_tad').change(function(e) {
        var val = jQuery(this).val();
        if (val == 1) {
            jQuery('.div_date_cachet').show();
            jQuery('.div_date_cachet input').prop('required', true);
        } else {
            jQuery('.div_date_cachet').hide();
            jQuery('.div_date_cachet input').prop('required', false);
        }
    });

    
    jQuery('.div_question_select select').change(function(e) {
      var val = jQuery(this).val();
      if (val === '') {
          jQuery('.div_question input').val('');
      } else {
          jQuery('.div_question input').val(val);
      }
  });
    
  jQuery('select.select_filtre').change(function(e) {
      var val = jQuery(this).val();
      var id = jQuery(this).attr('data-id');
      jQuery.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          'action': 'select_filtre',
          'val': val,
          'id': id
        }
      }).done(function(response) {
        window.location = window.location.href.split("?")[0];
      });
  });

  jQuery('.id-externe-inconnu').change(function(e) {
    if (jQuery(this).is(':checked')) {
      jQuery('.id-externe').prop('required', false);
      jQuery('.id-externe').val('');
      jQuery('.id-externe').prop('disabled', true);
    } else {
      jQuery('.id-externe').prop('required', true);
      jQuery('.id-externe').val('');
      jQuery('.id-externe').prop('disabled', false);
    }
  });

  jQuery('.lieu_adresse').change(function(e) {
    var val = jQuery(this).val();
    if (val != '') {
      jQuery('.adresse_map').submit();
    }
  });

  jQuery('.id-externe').change(function(e) {
    var val = jQuery(this).val();
    if (val != '') {
      var regex = /[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/;
      if (!val.match(regex)) { 
        jQuery('.id-externe').val('');
        alert('L\'identifiant externe doit avoir la forme suivante sans espace : lettre chiffre lettre chiffre lettre chiffre.');
      } 
    }
  });

  jQuery('.auto-submit-text').change(function(e) {
    var val = jQuery(this).val();
    jQuery('#auto-submit-text').val(val);
    jQuery('#auto-submit').submit();
  });

  jQuery('.auto-submit').change(function(e) {
    jQuery('#page_search').val(1);
    jQuery('#auto-submit').submit();
  });
  
    
    jQuery('.lieu_depot').change(function(e) {
        var val = jQuery(this).val();
        if (val == 'hdl') {
            jQuery('.div_lieu_hdl').show();
        } else {
            jQuery('.div_lieu_hdl').hide();
        }
    });
    
    jQuery('.code-postal input').change(function(e) {
      var code_postal_user = jQuery(this).attr('data-cp');
      var val = jQuery(this).val();
      if (val.substring(0,2) != code_postal_user.substring(0,2)) {
        alert('Le code postal du lieu de dépôt doit se situer dans votre département.');
      } else {
        jQuery('.select_ville').html('...');
          jQuery.ajax({
            url: ajaxurl,
            type: "POST",
            data: {
              'action': 'get_cities',
              'cp': val
            }
          }).done(function(response) {
            jQuery('.select_ville').html(response);
          });
      }
    });
    
    jQuery('.verif_valid_lieu').click(function(e) {
      var code_postal_user = jQuery('#code_postal').attr('data-cp');
      var val = jQuery('#code_postal').val();
      if (val.substring(0,2) != code_postal_user.substring(0,2)) {
        alert('Le code postal du lieu de dépôt doit se situer dans votre département.');
        e.preventDefault();
      }
    });
    
    jQuery('.retour_etape2').click(function(e) {
        jQuery('.input_etape3').val('0');
        jQuery('.form_etape3').submit();
    });
    
    jQuery('.nr_input').change(function(e) {
        var id = jQuery(this).attr('data-id');
        var hdl = jQuery(this).attr('data-hdl');
        if (jQuery(this).is(':checked')) {
          jQuery('.hdl_' + hdl + '_' + id).prop('required', false);
          jQuery('.hdl_' + hdl + '_' + id).prop('disabled', true);
          jQuery('.hdl_' + hdl + '_' + id).val('');
        } else {
          jQuery('.hdl_' + hdl + '_' + id).prop('required', true);
          jQuery('.hdl_' + hdl + '_' + id).prop('disabled', false);
        }
    });

    jQuery('body').on("click", '.add_cart', function(e) {
        jQuery('.panier').html('En cours de chargement...');
        e.preventDefault();
        var id = jQuery(this).attr('data-id');
        var points = jQuery(this).attr('data-points');
        var titre = jQuery(this).attr('data-titre');
        var id_catalogue = jQuery(this).attr('data-catalogue');
        var id_prestataire = jQuery(this).attr('data-prestataire');
        var qte = jQuery(this).parent().find('.quantite input').val();
        jQuery.ajax({
          url: ajaxurl,
          type: "POST",
          data: {
            'action': 'add_cart',
            'id': id,
            'qte': qte,
            'points': points,
            'id_prestataire': id_prestataire,
            'id_catalogue': id_catalogue,
            'titre': titre
          }
        }).done(function(response) {
          jQuery('.panier').html(response);
          jQuery('.recap-panier-content').html('En cours de chargement...');
          jQuery.ajax({
            url: ajaxurl,
            type: "POST",
            data: {
              'action': 'cart_recap'
            }
          }).done(function(response) {
            jQuery('.recap-panier-content').html(response);
          });
        });
    });

    jQuery('.modale_produit').click(function(e) {
      e.preventDefault();
      var id = jQuery(this).attr('data-id');
      jQuery.ajax({
        url: ajaxurl,
        type: "GET",
        data: {
          'action': 'modale_produit',
          'id': id
        }
      }).done(function(response) {
        jQuery('#page').after(response);
      });
    });


    jQuery('body').on("click", '.voir_commande', function(e) {
      e.preventDefault();
      var id = jQuery(this).attr('data-id');
      var nb_lignes = jQuery(this).attr('data-nb');
      var date = jQuery(this).attr('data-date');
      jQuery.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          'action': 'voir_commande',
          'id': id
        }
      }).done(function(response) {
        jQuery('#boutique').after(response);
      });
    });

    jQuery('body').on("click", '.force-valid', function(e) {
      e.preventDefault();
      jQuery('.force_valid_input').val(1);
      jQuery('.force_valid_form').submit();
    });

    jQuery('body').on("click", '.verif-user', function(e) {
      if (jQuery('.user_newsletter_sms').is(':checked')) {
        var phone1 = jQuery('.user_telephone1').val();
        var phone2 = jQuery('.user_telephone2').val();
        if (phone1.substring(0, 2) != '06' && phone2.substring(0, 2) != '06' && phone1.substring(0, 2) != '07' && phone2.substring(0, 2) != '07') {
          alert('Merci de renseigner un numéro de téléphone mobile pour activer la fonctionnalité "Relances par SMS"');
          e.preventDefault();
        }
      }
      if (jQuery('.user_newsletter_email').is(':checked') && jQuery('.user_email').val() == '') {
        alert('Merci de renseigner une adresse E-Mail pour activer la fonctionnalité "Relances par EMail"');
        e.preventDefault();
      }
      if (!jQuery('.user_newsletter_email').is(':checked') && !jQuery('.user_newsletter_sms').is(':checked')) {
        var message = 'Vous n’avez pas renseigné la partie « information sur la mesure », confirmez-vous ne pas vouloir être contacté par Email et/ou par Sms sur les actions menées sur la Mesure Lettre ?';
        if (window.confirm(message)) { 
        } else {
            e.preventDefault();
        }
      }
    });

    jQuery('body').on("blur", ".date-absence input", function() {
        var debut = jQuery('.date-debut-absence input').val();
        var fin = jQuery('.date-fin-absence input').val();
        if (debut != '' && fin != '') {
          var nb_jours = Number(dayDiff(debut, fin));
          if (nb_jours < 0) {
            alert('La date de début est supérieure à la date de fin');
            jQuery(this).val('');
          } else {
            jQuery('.nb_jours').html((nb_jours + 1));
          }
        }
    });

    jQuery('body').on("change", ".quantite_panier", function() {
        jQuery('.panier').html('En cours de chargement...');
        var id = jQuery(this).attr('data-id');
        var points = jQuery(this).attr('data-points');
        var titre = jQuery(this).attr('data-titre');
        var qte = jQuery(this).val();
        jQuery.ajax({
          url: ajaxurl,
          type: "POST",
          data: {
            'action': 'add_cart',
            'id': id,
            'qte': qte,
            'points': points,
            'titre': titre
          }
        }).done(function(response) {
          jQuery('.panier').html(response);
          jQuery('.recap-panier-content').html('En cours de chargement...');
          jQuery.ajax({
            url: ajaxurl,
            type: "POST",
            data: {
              'action': 'cart_recap'
            }
          }).done(function(response) {
            jQuery('.recap-panier-content').html(response);
          });
        });
    });

    jQuery('body').on("change", ".panier_don_input", function() {
        jQuery('.panier').html('En cours de chargement...');
        var don = jQuery(this).val();     
        jQuery.ajax({
          url: ajaxurl,
          type: "POST",
          data: {
            'action': 'change_don',
            'don': don
          }
        }).done(function(response) {
          jQuery('.panier').html(response);
          jQuery('.recap-panier-content').html('En cours de chargement...');
          jQuery.ajax({
            url: ajaxurl,
            type: "POST",
            data: {
              'action': 'cart_recap'
            }
          }).done(function(response) {
            jQuery('.recap-panier-content').html(response);
          });
        });
    });

    jQuery('body').on("click", '.delete_product', function() {
      var message = 'Êtes-vous certain de vouloir supprimer ce produit de votre panier ?';
        if (window.confirm(message)) { 
          jQuery('.panier').html('En cours de chargement...');
           var id = jQuery(this).attr('data-id');
           jQuery.ajax({
             url: ajaxurl,
             type: "POST",
             data: {
               'action': 'delete_cart',
               'id': id
             }
           }).done(function(response) {
             jQuery('.panier').html(response);
             jQuery('.recap-panier-content').html('En cours de chargement...');
             jQuery.ajax({
               url: ajaxurl,
               type: "POST",
               data: {
                 'action': 'cart_recap'
               }
             }).done(function(response) {
               jQuery('.recap-panier-content').html(response);
             });
           });
        } else {
            e.preventDefault();
        }
    });

    jQuery('body').on("click", '.order_button', function(e) {
        e.preventDefault();
        jQuery.ajax({
          url: ajaxurl,
          type: "POST",
          data: {
            'action': 'recap_panier'
          }
        }).done(function(response) {
          jQuery('.panier').after(response);
        });
    });
});
